module.exports = __webpack_public_path__ + "img/ch2.2e7e554b.png";